import all from './all.json';

import demo from './demo.json';
import el from './el.json';

export default {
  ...all,
  demo,
  el
};
